import React, {useCallback } from "react"
import { signInWithRedirect } from "aws-amplify/auth"
import { Button } from "@aws-amplify/ui-react"

type Props = {
  providerName: string
  setError: React.Dispatch<React.SetStateAction<string | null>>
}

export default function IdpSignInButton({ providerName, setError }: Props) {
  const handleSignIn = useCallback(async () => {
    try {
      await signInWithRedirect({ provider: { custom: providerName } })
    } catch (err) {
      console.error("IdP sign-in failed", err)
      setError("Sign-in failed")
    }
  }, [providerName])
  return (
    <Button onClick={handleSignIn} variation="primary" data-testid={`idp-signin-${providerName}`}>
      {`Sign in with ${providerName}`}
    </Button>
  )
}
